import React from "react";

const Debit = ({ className }) => {

    return(
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_586_4763)">
            <path d="M3.66669 11.8334C4.21897 11.8334 4.66669 11.3857 4.66669 10.8334C4.66669 10.2811 4.21897 9.83337 3.66669 9.83337C3.1144 9.83337 2.66669 10.2811 2.66669 10.8334C2.66669 11.3857 3.1144 11.8334 3.66669 11.8334Z" fill="#64748B"/>
            <path d="M12.6667 2.5H3.33333C2.4496 2.50106 1.60237 2.85259 0.97748 3.47748C0.352588 4.10237 0.00105857 4.9496 0 5.83333L0 11.1667C0.00105857 12.0504 0.352588 12.8976 0.97748 13.5225C1.60237 14.1474 2.4496 14.4989 3.33333 14.5H12.6667C13.5504 14.4989 14.3976 14.1474 15.0225 13.5225C15.6474 12.8976 15.9989 12.0504 16 11.1667V5.83333C15.9989 4.9496 15.6474 4.10237 15.0225 3.47748C14.3976 2.85259 13.5504 2.50106 12.6667 2.5ZM3.33333 3.83333H12.6667C13.1971 3.83333 13.7058 4.04405 14.0809 4.41912C14.456 4.79419 14.6667 5.3029 14.6667 5.83333H1.33333C1.33333 5.3029 1.54405 4.79419 1.91912 4.41912C2.29419 4.04405 2.8029 3.83333 3.33333 3.83333ZM12.6667 13.1667H3.33333C2.8029 13.1667 2.29419 12.956 1.91912 12.5809C1.54405 12.2058 1.33333 11.6971 1.33333 11.1667V7.16667H14.6667V11.1667C14.6667 11.6971 14.456 12.2058 14.0809 12.5809C13.7058 12.956 13.1971 13.1667 12.6667 13.1667Z" fill="#64748B"/>
            </g>
            <defs>
            <clipPath id="clip0_586_4763">
            <rect width="16" height="16" fill="white" transform="translate(0 0.5)"/>
            </clipPath>
            </defs>
        </svg>

    )
}

export default Debit;